import { Directive, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[type=text][emptyToUndefined]',
  standalone: false,
})
export class EmptyToUndefinedDirective {
  constructor(@Self() private ngControl: NgControl) {
    ngControl.control?.valueChanges.subscribe((value) => {
      if (value === '') {
        ngControl.control?.setValue(undefined, { emitEvent: false });
      }
    });
  }
}
